import type { Metadata } from "next";
import AdminUserEdit from "@/Component/Common/AdminUserEdit";

export const metadata: Metadata = {
    title: "Edit Influencer | Connector Club",
    description: "",
};

const AdminInfluencerEditPage = async ({ params }: { params: Promise<{ UserSlug: string }>; }) => {
    const resolvedParams = await params;
    const userSlug = Array.isArray(resolvedParams.UserSlug)
        ? resolvedParams.UserSlug[0]
        : resolvedParams.UserSlug;
    
    return <AdminUserEdit userSlug={userSlug} />;
};

export default AdminInfluencerEditPage;
